import React from 'react';

interface Props {
  className?: string;
  tags?: WordpressTag[];
}

const Tag = ({ tag }: { tag: WordpressTag }) => {
  return (
    <a
      href={`/tags/${tag.slug}`}
      className='inline-block mb-2 bg-abn-gray text-gray-800 py-1 px-2 mr-2 rounded'
    >
      {tag.name}
    </a>
  );
};

const TagList = ({ tags, className }: Props) => {
  if (!tags || !tags.length) {
    return null;
  }
  return (
    <div className={className}>
      <p className='mb-2'>Related tags: </p>
      {tags.map(tag => (
        <Tag key={tag.slug} tag={tag} />
      ))}
    </div>
  );
};

export default TagList;
